export const REFUND_DELAY_DAYS = 2
